import React from 'react';
import LandingHero from '../features/landing/components/LandingHero';
import LandingLogos from '../features/landing/components/LandingLogos';
import LandingDemo from '../features/landing/components/LandingDemo';
import LandingFeatures from '../features/landing/components/LandingFeatures';
import LandingHowItWorks from '../features/landing/components/LandingHowItWorks';
import LandingUseCases from '../features/landing/components/LandingUseCases';
import LandingTestimonials from '../features/landing/components/LandingTestimonials';
import LandingPricing from '../features/landing/components/LandingPricing';
import LandingFooter from '../features/landing/components/LandingFooter';

interface LandingPageProps {
  onEnterApp: () => void;
}

const LandingPage: React.FC<LandingPageProps> = ({ onEnterApp }) => {
  return (
    <div className="min-h-screen font-inter text-black bg-white selection:bg-black selection:text-white flex flex-col">
      <LandingHero onEnterApp={onEnterApp} />
      <LandingLogos />
      <LandingDemo />
      <LandingFeatures />
      <LandingHowItWorks />
      <LandingUseCases />
      <LandingTestimonials />
      <LandingPricing onEnterApp={onEnterApp} />
      <LandingFooter onEnterApp={onEnterApp} />
    </div>
  );
};

export default LandingPage;
